import React, { Component } from "react";
import PropTypes from "prop-types";

import Container from "pages/_components/Container";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import Drawer from "pages/_components/Drawer/Drawer";
import AccountsOfficerContact from "./AccountsOfficerContact";

const FORM_ID = "investmentFunds.accountOfficer";

class AccountsOfficer extends Component {
    static propTypes = {
        accountsOfficer: PropTypes.shape({
            email: PropTypes.string,
            name: PropTypes.string,
        }),
        isDesktop: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        accountsOfficer: {}, // valor por defecto para evitar el warning
    };

    state = { openSidebar: false };

    handleContact = () => this.setState({ openSidebar: true });

    onClose = () => this.setState({ openSidebar: false });

    renderContact() {
        const { openSidebar } = this.state;
        const { isDesktop, accountsOfficer } = this.props;
        if (!accountsOfficer?.email) {
            return null;
        }

        return (
            <Drawer
                openSidebar={openSidebar}
                onClose={this.onClose}
                isFullHeight={!isDesktop}
                enableCloseButton={isDesktop}>
                <AccountsOfficerContact
                    openForm={openSidebar}
                    idForm={FORM_ID}
                    email={accountsOfficer.email}
                    onClose={this.onClose}
                />
            </Drawer>
        );
    }

    render() {
        const { accountsOfficer } = this.props;
        const name = accountsOfficer?.name || "";

        return (
            <>
                {this.renderContact()}

                <div className="above-the-fold">
                    <Container className="container--layout flex-grow">
                        <div
                            className="box"
                            style={{
                                position: "relative",
                                backgroundColor: "#EDF5F3",
                                borderRadius: 8,
                                padding: 16,
                            }}>
                            <CustomText
                                text="investmentFunds.dashboard.accountsOfficer"
                                textType="I18N"
                                className="loans-box-title"
                            />

                            <div style={{ marginTop: 12, fontSize: 16, color: "#333" }}>{name}</div>

                            <div
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: 16,
                                    transform: "translateY(-50%)",
                                }}>
                                <Button
                                    image="images/figma/icon/arrow-right.svg"
                                    bsStyle="link"
                                    label="investmentFunds.dashboard.contact"
                                    onClick={this.handleContact}
                                />
                            </div>
                        </div>
                    </Container>
                </div>
            </>
        );
    }
}

export default AccountsOfficer;
